import styled from "styled-components";

export const Container = styled.div``;

export const Text = styled.div`
  color: #333;
  font-size: 14px;
  font-weight: 400;
`;

export const Label = styled.label`
  color: #666;
  font-family: 'Montserrat', sans-serif;
  font-size: 13px;
  font-weight: 500;
`;

export const Title = styled.h1`
  color: #666;
  font-family: 'Montserrat', sans-serif;
  font-size: 15px;
  font-weight: 500;
`;

export const BoldTitle = styled(Title)`
  color: #333;
  font-size: 20px;
  font-weight: 600;
`;

export const Description = styled.p`
  color: #999;
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  font-weight: 400;
`;

export const TextDate = styled.span`
  color: #999;
  font-size: 12px;
  font-weight: 400;
  font-family: 'Montserrat', sans-serif;
`;

export const Button = styled.button`
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  line-height: 24px;
  padding: 12px 24px;
  border: none;
  cursor: pointer;
  border-radius: 6px;
  background: #3483fa;
  width: 100%;
  transition: background 0.2s;
  &:hover {
    background: #2968c8;
  }
  &:active {
    background: #1f54a0;
  }
`;

export const AddButton = styled.div`
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  font-family: 'Montserrat', sans-serif;
  line-height: 1;
  padding: 10px 16px;
  background-color: #3483fa;
  border-radius: 4px 4px 0 0;
  transition: background 0.2s;
  white-space: nowrap;
  &:hover {
    background-color: #2968c8;
  }
  &:before {
    content: "+";
    font-size: 14px;
    margin-right: 5px;
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px 12px;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  line-height: 24px;
  border: 1px solid #ddd;
  border-radius: 6px;
  margin-bottom: 16px;
  background: #fff;
  color: #333;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: #3483fa;
    box-shadow: 0 0 0 1px #3483fa22;
  }

  &::placeholder {
    color: #aaa;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 10px 12px;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  line-height: 24px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #fff;
  color: #333;
  height: 400px;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: #3483fa;
    box-shadow: 0 0 0 1px #3483fa22;
  }
`;

export const FH = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Col2Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const DropHere = styled.div`
  width: 100%;
  height: 160px;
  border: 2px dashed #ddd;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #bbb;
  flex-direction: column;
  cursor: pointer;
  background-color: #fafafa;
  &:hover {
    background-color: #f0f7ff;
    border-color: #3483fa66;
    color: #3483fa;
  }
  transition: all 0.2s ease;
`;
